import {
  LOGIN_START,
  CLEAR_PO,

  UPDATE_GR_DETAIL,
  UPDATE_GR_ITEM,
  UPDATE_GR_SERVICE_ITEM,
  UPDATE_GR_SERVICE_LINE,
  UPDATE_GR_ITEM_ACCOUNT_ASSIGNMENT,
  UPDATE_GR_SERVICE_ACCOUNT_ASSIGNMENT,
  UPDATE_GR_ITEM_MODAL,
  UPDATE_GR_SERVICELINE_MODAL,
  UPDATE_NEW_ASSET,

  UPDATE_IR_ONE_TIME_VENDOR,
  UPDATE_IR_ONE_TIME_VENDOR_MODAL,
  UPDATE_MR_DETAIL,
  UPDATE_MR_EVAL,
  UPDATE_MR_EVAL_CHANGE,
  UPDATE_MR_VENDOR,
  GET_MR_REF_DATA,
  GET_MR_REF_VENDOR,
  CLEAR_MR_VENDOR,
  UPDATE_MR_ATTACHMENT,
  UPDATE_EVALUATION_MODAL,
  CLEAR_EVALUATION_MODAL,

  SELECT_ITEM_GR_SERVICE,
  SEARCH_PO_COMPLETED,
  SEARCH_PO_FAIL,
  SEARCH_PO_ORIGINAL,
  UPDATE_MR_IR_DESCRIPTION

} from "../actions/actionTypes";

import {
  data_t_HEADER,
  data_t_PO_DETAIL,
  data_t_PO_COMMITTEE,
  data_t_GR_DETAIL,
  data_t_GR_ITEM,
  data_t_GR_ITEM_ACCOUNT_ASSIGNMENT,
  data_t_GR_SERVICE,
  data_t_GR_SERVICELINE,
  data_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
  data_t_IR_DETAIL,
  data_t_IR_ITEM,
  data_t_IR_TAXS,
  data_t_IR_ONE_TIME_VENDOR,
  data_t_IR_ITEM_ACCOUNT_ASSIGNMENT,
  data_t_IR_SERVICELINE,
  data_t_MR_DETAIL,
  data_t_MR_EVAL,
  data_t_MR_VENDOR,
  data_t_MR_ATTACHMENTS,
  data_t_NEW_ASSET,
  data_t_MR_IR_DESCRIPTION
} from '../../configs/datas'

const initialState = {
  transaction_uid: null,
  transaction_no: null,
  viewMode: null,
  po_no: null,
  status: null,
  docementType: "",
  po_original: {
    "t_GR_ITEM": data_t_GR_ITEM,
    "t_GR_SERVICE": data_t_GR_SERVICE,
    "t_GR_SERVICELINE": data_t_GR_SERVICELINE,
    "t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT": data_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
  },
  transaction: {
    "t_HEADER": data_t_HEADER,
    "t_PO_DETAIL": data_t_PO_DETAIL,
    "t_PO_COMMITTEE": data_t_PO_COMMITTEE,
    "t_GR_DETAIL": data_t_GR_DETAIL,
    "t_GR_ITEM": data_t_GR_ITEM,
    "t_GR_ITEM_ACCOUNT_ASSIGNMENT": data_t_GR_ITEM_ACCOUNT_ASSIGNMENT,
    "t_GR_SERVICE": data_t_GR_SERVICE,
    "t_GR_SERVICELINE": data_t_GR_SERVICELINE,
    "t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT": data_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
    "t_IR_DETAIL": data_t_IR_DETAIL,
    "t_IR_TAXS": data_t_IR_TAXS,
    "t_IR_ITEM": data_t_IR_ITEM,
    "t_IR_ONE_TIME_VENDOR": data_t_IR_ONE_TIME_VENDOR,
    "t_IR_ITEM_ACCOUNT_ASSIGNMENT": data_t_IR_ITEM_ACCOUNT_ASSIGNMENT,
    "t_IR_SERVICELINE": data_t_IR_SERVICELINE,
    "t_MR_DETAIL": data_t_MR_DETAIL,
    "t_MR_EVAL": data_t_MR_EVAL,
    "t_MR_VENDOR": data_t_MR_VENDOR,
    "t_MR_ATTACHMENTS": data_t_MR_ATTACHMENTS,
    "t_NEW_ASSET": data_t_NEW_ASSET,
    "t_MR_IR_DESCRIPTION": [] //data_t_MR_IR_DESCRIPTION
  },
  itemModal: {},
  // serviceLineModal: {
  //   index: null
  // },
  oneTimeVendorModal: {},
  // selectItemGRService: [],

  //Cached States
  t_HEADER: data_t_HEADER,
  t_PO_DETAIL: data_t_PO_DETAIL,
  t_PO_COMMITTEE: data_t_PO_COMMITTEE,
  t_GR_DETAIL: data_t_GR_DETAIL,
  t_GR_ITEM: data_t_GR_ITEM,
  t_GR_ITEM_ACCOUNT_ASSIGNMENT: data_t_GR_ITEM_ACCOUNT_ASSIGNMENT,
  t_GR_SERVICE: data_t_GR_SERVICE,
  t_GR_SERVICELINE: data_t_GR_SERVICELINE,
  t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: data_t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
  t_IR_DETAIL: data_t_IR_DETAIL,
  t_IR_TAXS: data_t_IR_TAXS,
  t_IR_ITEM: data_t_IR_ITEM,
  t_IR_ONE_TIME_VENDOR: data_t_IR_ONE_TIME_VENDOR,
  t_IR_ITEM_ACCOUNT_ASSIGNMENT: data_t_IR_ITEM_ACCOUNT_ASSIGNMENT,
  t_IR_SERVICELINE: data_t_IR_SERVICELINE,
  t_MR_DETAIL: data_t_MR_DETAIL,
  t_MR_EVAL: data_t_MR_EVAL,
  t_MR_VENDOR: data_t_MR_VENDOR,
  t_MR_ATTACHMENTS: data_t_MR_ATTACHMENTS,
  t_NEW_ASSET: data_t_NEW_ASSET,
  t_MR_IR_DESCRIPTION: [], //data_t_MR_IR_DESCRIPTION
  //End Cached States


  evaluationModal: {
    index: "",
    running: 0,
    transaction_no: null,
    temp_trans_att_no: null,
    id: null,
    vendor_code: null,
    vendor_name: null,
    vendor_group: null,
    evaluation_form_name: null,
    evaluator_id: null,
    evaluator_name: null,
    clear: false,
    vendor_group_desc: null,
    evaluation_form_name_desc: null,
    is_new_evaluation: true,
    is_enrgy:false
  },
  selected_service_item_no: null
}

function MainRedux(state = initialState, action) {
  let { transaction } = state

  switch (action.type) {
    case LOGIN_START:
      return initialState
    case CLEAR_PO:
      return initialState
    case SEARCH_PO_COMPLETED:
      return {
        ...state,
        transaction_no: action.tran_no,
        temp_trans_att_no : action.tempAttNo,
        viewMode: action.viewMode,
        po_no: action.po_no,
        status: action.status,
        transaction_uid: action.uid,
        docementType: action.transaction.returnData.docementType,
        transaction: {
          ...transaction,
          t_MR_IR_DESCRIPTION: action.transaction.t_MR_IR_DESCRIPTION,
          t_GR_SERVICE: action.transaction.t_GR_SERVICE,
          t_GR_SERVICELINE: action.transaction.t_GR_SERVICELINE,
          t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: action.transaction.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT
        },
        //Duplicate data to cached state
        t_HEADER: action.transaction.t_HEADER,
        t_PO_DETAIL: action.transaction.t_PO_DETAIL,
        t_PO_COMMITTEE: action.transaction.t_PO_COMMITTEE,
        t_GR_DETAIL: action.transaction.t_GR_DETAIL,
        t_GR_ITEM: action.transaction.t_GR_ITEM,
        t_GR_ITEM_ACCOUNT_ASSIGNMENT: action.transaction.t_GR_ITEM_ACCOUNT_ASSIGNMENT,
        t_GR_SERVICE: action.transaction.t_GR_SERVICE,
        t_GR_SERVICELINE: action.transaction.t_GR_SERVICELINE,
        t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: action.transaction.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
        t_IR_DETAIL: action.transaction.t_IR_DETAIL,
        t_IR_ITEM: action.transaction.t_IR_ITEM,
        t_IR_ONE_TIME_VENDOR: action.transaction.t_IR_ONE_TIME_VENDOR,
        t_IR_ITEM_ACCOUNT_ASSIGNMENT: action.transaction.t_IR_ITEM_ACCOUNT_ASSIGNMENT,
        t_IR_SERVICELINE: action.transaction.t_IR_SERVICELINE,
        t_IR_TAXS: action.transaction.t_IR_TAXS,
        t_MR_DETAIL: action.transaction.t_MR_DETAIL,
        t_MR_EVAL: action.transaction.t_MR_EVAL,
        t_MR_VENDOR: action.transaction.t_MR_VENDOR,
        t_MR_ATTACHMENTS: action.transaction.t_MR_ATTACHMENTS,
        t_NEW_ASSET: action.transaction.t_NEW_ASSET,
        t_MR_IR_DESCRIPTION: action.transaction.t_MR_IR_DESCRIPTION
      }
    case SEARCH_PO_ORIGINAL:
      //console.log(action);
      return {
        ...state,
        po_original: {
          t_GR_ITEM: action.po_original.t_GR_ITEM,
          t_GR_SERVICE: action.po_original.t_GR_SERVICE,
          t_GR_SERVICELINE: action.po_original.t_GR_SERVICELINE,
          t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: action.po_original.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
        },
      }
    case SEARCH_PO_FAIL:
      return state
    case UPDATE_GR_DETAIL: {
      return {
        ...state,
        t_GR_DETAIL: {
          ...state.t_GR_DETAIL,
          [action.fieldName]: action.data
        }
      }
    }

    case UPDATE_GR_ITEM:
      if (action.index === "") {
        if (action.clear === false) {
          return {
            ...state,
            t_GR_ITEM: [
              ...state.t_GR_ITEM,
              action.data,
            ]
          }
        } else {
          return {
            ...state,
            t_GR_ITEM: action.data
          }
        }
      } else if (action.fieldName !== "") {
        return {
          ...state,
          t_GR_ITEM: [
            ...state.t_GR_ITEM.map((data, index) => {
              if (index === Number(action.index)) {
                let updateItem = data
                updateItem[action.fieldName] = action.data
                return updateItem
              } else {
                return data
              }
            })
          ]
        }
      } else {
        return {
          ...state,
          t_GR_ITEM: [
            ...state.t_GR_ITEM.map((data, index) => {
              if (index === Number(action.index)) {
                return action.data
              } else {
                return data
              }
            })
          ]
        }
      }
    case UPDATE_GR_SERVICE_ITEM:
      if (action.index === "") {
        if (action.clear === false) {
          return {
            ...state,
            t_GR_SERVICE: [
              ...state.t_GR_SERVICE,
              action.data,
            ]
          }
        } else {
          return {
            ...state,
            t_GR_SERVICE: action.data
          }
        }
      } else if (action.fieldName !== "") {
        return {
          ...state,
          t_GR_SERVICE: [
            ...state.t_GR_SERVICE.map((data, index) => {
              if (index === Number(action.index)) {
                let updateItem = data
                updateItem[action.fieldName] = action.data
                return updateItem
              } else {
                return data
              }
            })
          ]
        }
      } else {
        return {
          ...state,
          t_GR_SERVICE: [
            ...state.t_GR_SERVICE.map((data, index) => {
              if (index === Number(action.index)) {
                return action.data
              } else {
                return data
              }
            })
          ]
        }
      }
    case UPDATE_GR_SERVICE_LINE:
      if (action.index === "") {
        if (action.clear === false) {
          return {
            ...state,
            t_GR_SERVICELINE: [
              ...state.t_GR_SERVICELINE,
              action.data
            ]
          }

        } else {
          return {
            ...state,
            t_GR_SERVICELINE: action.data
          }

        }

      } else if (action.fieldName !== "") {
        return {
          ...state,
          t_GR_SERVICELINE: [
            ...state.t_GR_SERVICELINE.map((data, index) => {
              if (index === Number(action.index)) {
                let updateItem = data
                updateItem[action.fieldName] = action.data
                return updateItem
              } else {
                return data
              }
            })
          ]
        }
      } else {
        return {
          ...state,
          t_GR_SERVICELINE: [
            ...state.t_GR_SERVICELINE.map((data, index) => {
              if (index === Number(action.index)) {
                return action.data
              } else {
                return data
              }
            })
          ]
        }
      }
    case UPDATE_GR_ITEM_ACCOUNT_ASSIGNMENT:
      console.log("UPDATE_GR_ITEM_ACCOUNT_ASSIGNMENT", action)
      if (action.index === "") {

        if (action.clear === false) {
          return {
            ...state,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT: [
              ...state.t_GR_ITEM_ACCOUNT_ASSIGNMENT,
              action.data
            ]
          }
        } else {
          return {
            ...state,
            t_GR_ITEM_ACCOUNT_ASSIGNMENT: action.data
          }
        }
      } else if (action.fieldName !== "") {
        return {
          ...state,
          t_GR_ITEM_ACCOUNT_ASSIGNMENT: [
            ...state.t_GR_ITEM_ACCOUNT_ASSIGNMENT.map((data, index) => {
              if (index === Number(action.index)) {
                let updateItem = data
                updateItem[action.fieldName] = action.data
                return updateItem
              } else {
                return data
              }
            })
          ]
        }
      } else if (action.data === "remove") {
        return {
          ...state,
          t_GR_ITEM_ACCOUNT_ASSIGNMENT: [
            ...state.t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter((data) => data.item_no !== action.index)
          ]
        }
      } else if (action.data === "removeOne") {
        return {
          ...state,
          t_GR_ITEM_ACCOUNT_ASSIGNMENT: [
            ...state.t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter((data) => data.item_no !== action.index && data.acc_id !== action.fieldName)
          ]
        }
      } else {
        return {
          ...state,
          t_GR_ITEM_ACCOUNT_ASSIGNMENT: [
            ...state.t_GR_ITEM_ACCOUNT_ASSIGNMENT.map((data, index) => {
              if (index === Number(action.index)) {
                return action.data
              } else {
                return data
              }
            })
          ]
        }
      }
    case UPDATE_GR_SERVICE_ACCOUNT_ASSIGNMENT:

      if (action.index === "") {

        if (action.clear === false) {
          return {
            ...state,
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: [
              ...state.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT,
              action.data
            ]
          }
        } else {
          return {
            ...state,
            t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: action.data
          }
        }
      } else if (action.fieldName !== "" && action.data !== "remove") {
        console.log(action)
        return {
          ...state,
          t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: [
            ...state.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.map((data, index) => {
              if (index === Number(action.index)) {
                let updateItem = data
                updateItem[action.fieldName] = action.data
                return updateItem
              } else {
                return data
              }
            })
          ]
        }
      } else if (action.data === "remove") {
        return {
          ...state,
          t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: [
            ...state.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.filter(data => !(data.service_line_no === action.fieldName && data.item_no === action.index))
          ]
        }
      } else {
        return {
          ...state,
          t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT: [
            ...state.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.map((data, index) => {
              if (index === Number(action.index)) {
                return action.data
              } else {
                return data
              }
            })
          ]
        }

      }

    case UPDATE_GR_ITEM_MODAL:
      return {
        ...state,
        itemModal: action.data
      }

    // case UPDATE_GR_SERVICELINE_MODAL:
    
    //   return {
    //     ...state,
    //     serviceLineModal: action.data
    //   }

    // case SELECT_ITEM_GR_SERVICE:
    //   console.log("SELECT_ITEM_GR_SERVICE",action.data);
    //   return {
    //     ...state,
    //     selectItemGRService: action.data
    //   }
    case UPDATE_NEW_ASSET:
      return {
        ...state,
        t_NEW_ASSET: action.payload
      }
    case GET_MR_REF_DATA:
      return {
        ...state,
        t_MR_DETAIL: action.payload
      }
    case GET_MR_REF_VENDOR:
      return {
        ...state,
        t_MR_VENDOR: action.payload,

      }
    case UPDATE_MR_DETAIL:
      //Update own data avoid many update state
      if (action.fieldName !== "") {
        return {
          ...state,
          t_MR_DETAIL: {
            ...state.t_MR_DETAIL,
            [action.fieldName]: action.data
          }
        }
      } else {
        console.log('UPDATE_MR_DETAIL:Merge')
        //Merge to transaction
        return {
          ...state,
          transaction: {
            ...transaction,
            t_MR_DETAIL: {
              ...state.t_MR_DETAIL
            },
            t_MR_VENDOR: state.t_MR_VENDOR
          }
        }
      }
    case UPDATE_MR_EVAL:
//addMREval
      let {t_MR_DETAIL,t_MR_VENDOR}=state 
      let evalHerd = action && action.data && action.data.length>0 ? action.data[0] : null;

      if(evalHerd)
      {
        t_MR_DETAIL.is_new_evaluation = evalHerd.is_new_evaluation;
        t_MR_DETAIL.is_enrgy = evalHerd.is_enrgy;
      }
      if(evalHerd == null){
        t_MR_DETAIL.is_new_evaluation = true;
        t_MR_DETAIL.is_enrgy = null;
      }

      if(
        evalHerd && evalHerd.evaluation_type 
        && ( 
          (t_MR_DETAIL.evaluation_type === "no_evaluation" && (t_MR_DETAIL.reason_id == null || t_MR_DETAIL.reason_id === 0))
          || t_MR_DETAIL.evaluation_type === null
        )

      )
      {
        t_MR_DETAIL.evaluation_type=evalHerd.evaluation_type
        if(evalHerd.evaluation_type === "genaral_evaluation" || evalHerd.evaluation_type === "consortium_evaluation")
        {
          
          let tempVender={};
          t_MR_VENDOR=[];
          for(let i=0;i<action.data.length;i++){
            let row = action.data[i];

            let evaId;
            let evaName;
            if(row.mr_doc_no && row.mr_doc_no !== "" && row.mr_doc_no!== null && row.mr_doc_no.length>0){
              evaId=row.evaluator_code;
              evaName=row.evaluator_name;
            }
            else{
              evaId = t_MR_DETAIL.receiver_code ? t_MR_DETAIL.receiver_code : null;
              evaName = t_MR_DETAIL.receiver_name ? t_MR_DETAIL.receiver_name : null;

              evaId = t_MR_DETAIL.eval_code ? t_MR_DETAIL.eval_code : evaId;
              evaName = t_MR_DETAIL.eval_name ? t_MR_DETAIL.eval_name : evaName;
            }


            tempVender=data_t_MR_VENDOR[0];
            tempVender.vendor_code = row.vendor_code;
            tempVender.vendor_name = row.vendor_name;
            tempVender.evaluation_form_name = row.form;
            tempVender.evaluation_form_name_desc = row.form_name;
            tempVender.evaluator_id = evaId;
            tempVender.evaluator_name = evaName;
            t_MR_VENDOR.push(tempVender);
          }
      }
    }

      return {
        ...state,
        t_MR_DETAIL:t_MR_DETAIL,
        t_MR_VENDOR:t_MR_VENDOR,
        t_MR_EVAL: action.data
      }
    case UPDATE_MR_EVAL_CHANGE:

      const vendor = action.vendor;
      const reason_id = action.reason_id;

      return{
        ...state,
        t_MR_VENDOR:vendor,
        t_MR_DETAIL:{
          ...state.t_MR_DETAIL,
          reason_id:reason_id
        }
      }

    case UPDATE_MR_VENDOR:
      if (action.index === "") {
        return {
          ...state,
          t_MR_VENDOR: [
            ...state.t_MR_VENDOR,
            action.data
          ]
        }

      } else if (action.fieldName !== "") {
        return {
          ...state,
          t_MR_VENDOR: state.t_MR_VENDOR.map((data, index) => {
            if (index === Number(action.index)) {
              let updateItem = data
              updateItem[action.fieldName] = action.data
              return updateItem
            } else {
              return data
            }
          })
        }
      } else if (action.data === "remove") {
        return {
          ...state,
          t_MR_VENDOR: state.t_MR_VENDOR.filter((data, index) => (index !== action.index))
        }
      } else {
        return {
          ...state,
          t_MR_VENDOR: state.t_MR_VENDOR.map((data, index) => {
            if (index === Number(action.index)) {
              return action.data
            } else {
              return data
            }
          })
        }
      }
    case UPDATE_MR_IR_DESCRIPTION:
      return {
        ...state,
/*         transaction: {
          ...transaction,
          t_MR_IR_DESCRIPTION: action.data     
        },
 */        t_MR_IR_DESCRIPTION: action.data
      }
    case CLEAR_MR_VENDOR:
      return {
        ...state,
        t_MR_VENDOR: []
      }


    case UPDATE_MR_ATTACHMENT:
      if (action.index === "") {
        return {
          ...state,
          transaction: {
            ...transaction,
            t_MR_ATTACHMENTS: [
              ...transaction.t_MR_ATTACHMENTS,
              action.data
            ]
          }
        }
      } else if (action.fieldName !== "") {
        return {
          ...state,
          transaction: {
            ...transaction,
            t_MR_ATTACHMENTS: transaction.t_MR_ATTACHMENTS.map((data, index) => {
              if (index === Number(action.index)) {
                let updateItem = data
                updateItem[action.fieldName] = action.data
                return updateItem
              } else {
                return data
              }
            })
          }
        }
      } else {
        return {
          ...state,
          transaction: {
            ...transaction,
            t_MR_ATTACHMENTS: transaction.t_MR_ATTACHMENTS.map((data, index) => {
              if (index === Number(action.index)) {
                return action.data
              } else {
                return data
              }
            })
          }
        }
      }
    case UPDATE_EVALUATION_MODAL:

      return {
        ...state,
        evaluationModal: action.data
      }

    case CLEAR_EVALUATION_MODAL:

      return {
        ...state,
        evaluationModal: initialState.evaluationModal
      }

    // case UPDATE_IR_ONE_TIME_VENDOR:
    //   return {
    //     ...state,
    //     oneTimeVendorModal: action.data,
    //   }

    case UPDATE_IR_ONE_TIME_VENDOR_MODAL:
      return {
        ...state,
        t_IR_ONE_TIME_VENDOR: action.data
      }
    default:
      return { ...state };
  }
}

export default MainRedux;
